import React, { useState, useEffect } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { COMMON_URL, ADD_UPDATE_CHART_OF_ACCOUNT_DETAILS, POST_COA } from "../../utils/constants";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import {
  useFetchCoaAllLevelQuery,
  useLazyGetAllCoaDataQuery,
  useGetDetailTypesQuery,
  usePostCoaDataMutation,
  usePutCoaDataMutation,
} from "../../utils/accounting/chartOfAccount";
import { Checkbox, FormControlLabel } from "@mui/material";
import { pushAlert } from "../../utils/alertSlice";
import { useDispatch } from "react-redux";

const AddAccount = ({ isOpen, onClose, setData, formData, setFormData, isEditMode }) => {
  const user = useRequireAuth();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const myUserData = localStorage.getItem("myUserData");
  const parsedUserData = JSON.parse(myUserData);

  const [currencyData, setcurrencyData] = useState(null);
  const [selectedAccountCode, setSelectedAccountCode] = useState(null);
  const [fieldError, setFieldError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [parentAccountCode, setParentAccountCode] = useState(null);
  const [activeTab, setActiveTab] = useState("#All");
  // const [formData, setFormData] = useState({
  //   account_type: "",
  //   account_name: "",
  //   account_number: "",
  //   sub_account: false,
  //   descriptions: "",
  //   balance_as_on_date: "",
  //   amount: "",
  //   currency: "",
  // });

  const [errors, setErrors] = useState({
    account_type: "",
    account_name: "",
    account_number: "",
    balance_as_on_date: "",
    amount: "",
    currency: "",
  });

  const dispatch = useDispatch();

  const { data, error, isLoading, refetch } = useFetchCoaAllLevelQuery({ token: user?.token });
  const { data: detailTypes } = useGetDetailTypesQuery(
    { token: user?.token, account_code: selectedAccountCode },
    {
      skip: !selectedAccountCode,
    }
  );
  const [putCoaData] = usePutCoaDataMutation();
  const getTransformedData = (val) => {
    const transformedData = val.map((obj) => {
      let transformedObj = {};

      Object.keys(obj).forEach((key, index) => {
        transformedObj[key] = {
          value: obj[key],
          type: null,
          field_options: null,
          table_name: null,
          field_name: key,
          id: index,
        };
      });

      return transformedObj;
    });

    return transformedData;
  };

  const getFilteredData = (data) => {
    console.warn(data, "asdfgdfxzd");
    switch (activeTab) {
      case "Assets":
        return data.filter((item) => item.account_name === "Assets");
      case "Liabilities":
        return data.filter((item) => item.account_name === "Liabilities");
      case "Equity":
        return data.filter((item) => item.account_name === "Equity");
      case "Income":
        return data.filter((item) => item.account_name === "Income");
      case "Expenses":
        return data.filter((item) => item.account_name === "Expenses");
      default:
        return data; // return all data if no activeTab matches
    }
  };
  function generateRandomSixDigitNumber() {
    return Math.floor(100000 + Math.random() * 900000);
  }

  const [triggerGetAllCoaData, { data: responseData }] = useLazyGetAllCoaDataQuery();
  const [postCoaData] = usePostCoaDataMutation();

  const closeoutsideclick = useClickOutside(() => {
    onClose();
  });
  const getDetailsType = (value) => {
    const filteredData = data?.data?.filter((item) => item.id == value);

    const account_code = filteredData[0]?.account_code;
    setSelectedAccountCode(account_code);
    setParentAccountCode(account_code);
  };

  const handleChange = (e) => {
    const { name, key, type, checked, value } = e.target;

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === "checkbox" ? checked : value,
    }));

    if (name === "account_type") {
      getDetailsType(value);
      handleAccountChange(value);
    }
    if (name === "parent_account") {
      setParentAccountCode(value);
    }
  };

  const handleAccountChange = (accountId) => {
    const selectedAccount = data.data.find((item) => item.id === accountId);

    if (selectedAccount) {
      handleAddCoaData(selectedAccount.account_code);
    }
  };

  // Function to trigger lazy POST request
  const handleAddCoaData = (accountCode) => {
    triggerGetAllCoaData({
      token: user?.token,
      org_id: user?.org_id,
      company_id: parsedCompanyData.company_id,
      parent_account_code: accountCode,
    });
  };
  //   useEffect(()=>{
  // setData(responseData?.data)
  //   },[responseData])
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (isEditMode) {
      const putData = {
        org_id: user?.org_id,
        company_id: parsedCompanyData.company_id,
        account_name: formData?.account_name,
        description: formData?.descriptions,
        is_active: 1,
      };
      const response = await putCoaData({
        token: user?.token,
        accountCode: isEditMode,
        coaData: putData,
      });
      onClose();
    }
    if (!isEditMode) {
      const coaData = {
        org_id: user?.org_id,
        company_id: parsedCompanyData.company_id,
        //account_code: faker.datatype.number({ min: 100000, max: 999999 }),
        account_code: generateRandomSixDigitNumber(),
        account_name: formData.account_name,
        parent_account_code: parentAccountCode,
        description: formData.descriptions,
        is_active: 1,
        created_by: parsedUserData.user_id,
        opening_balance: formData.amount,
        balance_date: "2024-10-25",
      };
      try {
        const response = await postCoaData({
          token: user?.token,
          coaData: coaData, // Send the merged coaData
        }).unwrap();
        if (response?.success || response?.data?.success || response?.data?.status) {
          response.status
            ? dispatch(
                pushAlert({
                  visible: true,
                  message: "Record Updated Successfully",
                  type: "success",
                })
              )
            : dispatch(
                pushAlert({
                  visible: true,
                  message: "Failed to update record",
                  type: "danger",
                })
              );
        }
      } catch (err) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Something went wrong",
            type: "danger",
          })
        );
        console.error("Submission Error:", err);
      }
    }

    try {
      const responseData = await triggerGetAllCoaData({
        token: user?.token,
        org_id: user?.org_id,
        company_id: parsedCompanyData.company_id,
      }).unwrap();

      setData(responseData?.data);
    } catch (error) {
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
      console.error("Error:", error);
    }

    // triggerGetAllCoaData({
    //   token: user?.token,
    //   org_id: user?.org_id,
    //   company_id: parsedCompanyData.company_id,

    // });

    // //let filteredData = getFilteredData(responseData?.data);

    //setData(responseData?.data)
    onClose();
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.account_type) {
      newErrors.account_type = "Select an option";
    }
    if (!formData.account_name) {
      newErrors.account_name = "Enter Account Name";
    }
    if (!formData.account_number) {
      newErrors.account_number = "Enter Account Number";
    }
    if (!formData.currency) {
      newErrors.currency = "Enter Currency ";
    }
    if (!formData.balance_as_on_date) {
      newErrors.balance_as_on_date = "Enter Balance Date";
    }
    if (!formData.amount) {
      newErrors.amount = "Enter Amount";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form
    // const isFormValid = validateForm();

    // if (isFormValid) {
    setFormData({
      account_type: "",
      account_name: "",
      account_number: "",
      balance_as_on_date: "",
      amount: "",
      currency: "",
    });

    const formDataWithFile = new FormData();
    formDataWithFile.append("account_type", formData.account_type);
    formDataWithFile.append("account_name", formData.account_name);
    formDataWithFile.append("account_number", formData.account_number);
    formDataWithFile.append("balance_as_on_date", formData.balance_as_on_date);
    formDataWithFile.append("amount", formData.amount);
    formDataWithFile.append("currency", formData.currency);
    formDataWithFile.append("descriptions", formData.descriptions);

    try {
      const response = await fetch(ADD_UPDATE_CHART_OF_ACCOUNT_DETAILS, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
        body: formDataWithFile,
      });

      if (!response.ok) {
        throw new Error("Failed to save data");
      }

      const data = await response.json();
      if (data?.status || data?.data?.success || data?.data?.status) {
        dispatch(
          pushAlert({
            visible: true,
            message: "Records saved successfully",
            type: "success",
          })
        );
        // setSuccessMessage("Records saved successfully");
      } else {
        dispatch(
          pushAlert({
            visible: true,
            message: "Failed to save data",
            type: "danger",
          })
        );
        // setFieldError("Failed to save data");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      dispatch(
        pushAlert({
          visible: true,
          message: "Something went wrong",
          type: "danger",
        })
      );
    }
    // } else {
    //   setFieldError("Please Fill All Detail.");
    // }
  };

  useEffect(() => {
    const fetchData = async () => {
      const Authtoken = user.token;
      try {
        const response = await fetch(COMMON_URL, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        if (data.status === false) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        setcurrencyData(data?.data?.currency);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  setTimeout(() => {
    setFieldError("");
    setSuccessMessage("");
    setErrors("");
  }, 3000);

  const renderOptions = (data, level = 0) => {
    return data.map((item) => (
      <React.Fragment key={item.id}>
        <option value={item.account_code}>{`${" \u00A0".repeat(level)} ${item.account_name}`}</option>
        {item.children && item.children.length > 0 && renderOptions(item.children, level + 1)}
      </React.Fragment>
    ));
  };

  return (
    <div
      className={`fixed inset-y-0 inset-x-150  z-[9999] grid h-screen w-[96%] place-items-center bg-black bg-opacity-1 transition-opacity duration-300   ${
        isOpen ? "translate-x-0" : "translate-x-full"
      } transform transition-transform duration-500 ease-in-out`}
      style={{
        background: "rgba(44, 73, 93, 0.35)",
        backdropFilter: "blur(1.55px)",
      }}
    >
      <div
        ref={closeoutsideclick}
        className="absolute right-0 p-4 bg-white border border-E5ECF0 font-poppins leading-relaxed antialiased shadow-1 h-full w-[660px]"
      >
        <div className="p-2 h-full px-0">
          <div className="flex items-center justify-between p-4 pl-0 border-b border-BECBD3 rounded-t">
            <div>
              {fieldError && <p className="text-red-700">{fieldError}</p>}
              {successMessage && <p className="text-green-700">{successMessage}</p>}
              <br className="mb-2" />
            </div>
            <br />
            <h3 className="text-2xl text-434852">New Account (L2)</h3>

            <button
              onClick={onClose}
              type="button"
              className="text-454545 bg-transparent hover:bg-F1F5F8 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
              data-modal-hide="assets-modal"
            >
              {/* <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg> */}
              <CloseModalImg className="w-3 h-3" />
              <span className="sr-only">Close modal</span>
            </button>
          </div>

          <form onSubmit={handleFormSubmit} className="w-full">
            <div className="flex flex-row px-0 pt-2">
              <div className="basis-3/5 mb-3 pe-3">
                <label htmlFor="account_name" className="block mb-2 text-sm text-434852">
                  Account Name *
                </label>

                {/* <select
                      id="account_name"
                      name="account_name"
                      value={formData.account_name}
                      onChange={handleChange}
                      className="form-select bg-white border border-DFE2E5 text-gray-900 text-sm block w-full px-2.5 py-0"
                      disabled={!formData.account_type}
                    >
                 

                        {responseData &&
                        responseData?.data?.map((item) => (
                        
                                <option key={item.id} value={item.id}>
                                      {item.account_name}
                                </option>

                        ))}

                      
                    </select> */}

                <input
                  type="text"
                  id="account_name"
                  name="account_name"
                  value={formData.account_name}
                  onChange={handleChange}
                  className="bg-white border border-DFE2E5 text-gray-900 text-sm block w-full p-2.5"
                  //disabled={!formData.account_type}
                />

                <div className="text-sm text-red-400">{errors.account_name}</div>
              </div>
              <div className="basis-2/5 mb-3">
                <label htmlFor="account_number" className="block mb-2 text-sm text-434852">
                  Account Number
                </label>
                <input
                  type="text"
                  id="account_number"
                  name="account_number"
                  value={formData.account_number}
                  onChange={handleChange}
                  className="bg-white border border-DFE2E5 text-gray-900 text-sm block w-full p-2.5"
                  disabled={!formData.account_type}
                />

                <div className="text-sm text-red-400">{errors.account_number}</div>
              </div>
            </div>

            <div className="flex flex-row px-0">
              <div className="basis-3/5 pe-3">
                <label htmlFor="account_type" className="block mb-2 text-sm text-434852">
                  Account Type *
                </label>

                <select
                  id="account_type"
                  name="account_type"
                  value={formData.account_type}
                  onChange={handleChange}
                  className="form-select bg-white border border-DFE2E5 text-gray-900 text-sm block w-full px-2.5 py-0"
                >
                  <option disabled selected></option>
                  {data &&
                    data?.data?.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.account_name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="basis-2/5">
                <label htmlFor="detail_type" className="block mb-2 text-sm text-434852">
                  Detail Type *
                </label>

                <select
                  id="detail_type"
                  name="detail_type"
                  value={formData.detail_type}
                  onChange={handleChange}
                  className="form-select bg-white border border-DFE2E5 text-gray-900 text-sm block w-full px-2.5 py-0"
                  disabled={!formData.account_type}
                >
                  <option value="" disabled hidden></option>
                  {detailTypes &&
                    detailTypes.map((item) => (
                      <option key={item.id} value={item.detail_name}>
                        {item.detail_name}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <FormControlLabel
              name="sub_account"
              control={<Checkbox checked={formData.sub_account} onChange={handleChange} />}
              label="Make This A Subaccount"
              labelPlacement="end"
              sx={{
                "& .MuiFormControlLabel-label": {
                  color: "#2C495D",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 400,
                  textTransform: "capitalize",
                },
              }}
            />

            {formData.sub_account && (
              <div className="px-0 pb-3">
                <label htmlFor="parent_account" className="block mb-2 text-sm text-434852">
                  Parent Account *
                </label>

                <select
                  id="parent_account"
                  name="parent_account"
                  // value={formData.parent_account}
                  onChange={handleChange}
                  className="form-select bg-white border border-DFE2E5 text-gray-900 text-sm block w-full px-2.5 py-0"
                >
                  {/* {responseData &&
                        responseData?.data?.map((item) => (
                        
                                <option key={item.id} value={item.id}>
                                      {item.account_name}
                                </option>

                        ))} */}
                  {responseData && responseData.data && renderOptions(responseData.data)}
                </select>
              </div>
            )}
            <div className="grid px-0 pb-3">
              <label htmlFor="description" className="block mb-2 text-sm text-434852">
                Description *
              </label>
              <textarea
                id="descriptions"
                name="descriptions"
                rows="4"
                value={formData.descriptions}
                onChange={handleChange}
                className="bg-white border border-DFE2E5 text-gray-900 text-sm block w-full p-2.5"
              ></textarea>
            </div>
            <div className="flex justify-between w-full px-0">
              <div className="mb-3 pe-3 mr-2">
                <label htmlFor="balanceDate" className="block text-sm text-434852 mb-1 mt-2 ml-1">
                  Balance as on Date
                </label>
                <input
                  type="date"
                  id="balance_as_on_date"
                  name="balance_as_on_date"
                  value={formData.balance_as_on_date}
                  onChange={handleChange}
                  className="bg-white border border-DFE2E5 text-gray-900 text-sm block p-2.5"
                />
                <div className="text-sm text-red-400">{errors.balance_as_on_date}</div>
              </div>
              <div className="mb-3">
                <label htmlFor="amount" className="block text-sm text-434852 mb-1 mt-2 ml-1">
                  Amount
                </label>
                <input
                  type="amount"
                  id="amount"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  className="bg-white border border-DFE2E5 text-gray-900 text-sm block p-2.5"
                />
                <div className="text-sm text-red-400">{errors.amount}</div>
              </div>
            </div>
            <div className="flex justify-end items-end mt-20 text-md">
              <div>
                <button
                  onClick={onClose}
                  type="button"
                  className="w-28 text-535252 bg-F4F4F4 rounded-md hover:bg-eeeeee cancel-btn focus:ring-4 focus:ring-blue-300 font-medium px-5 py-2.5 text-center"
                >
                  CANCEL
                </button>

                <button
                  //onClick={handleSubmit}
                  type="submit"
                  className="w-28 text-white bg-1D4469 rounded-md hover:bg-20486F save-btn font-medium border border-gray-200 py-2.5 px-5 ms-3"
                >
                  SAVE
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddAccount;
